module.exports = __webpack_public_path__ + "img/dedicate-workspace.86d8acdd.svg";